import { SHARED_ITEM_TYPE } from '@/lib/constants';

import { SharedItemModel, SharedItemType } from '../types';

const URL_MAP: Record<SharedItemType, string> = {
  [SHARED_ITEM_TYPE.SHIPMENT]: 'tracking',
  [SHARED_ITEM_TYPE.COLLECTION]: 'tracking',
  [SHARED_ITEM_TYPE.SHIPMENT_VIEW]: 'tracking/list',
};

export const getSharedItemUrl = (sharedItem?: SharedItemModel | null): string => {
  if (!sharedItem) return '';
  return `/shared/${URL_MAP[sharedItem.type]}/${sharedItem?.id}`;
};
